import React from 'react';
import { LegalPage } from '@/components/legal';

export function Terms() {
  return (
    <LegalPage
      documentType="terms"
      title="Terms of Service"
      accentColor="blue"
    />
  );
}
